var React = require('react');

function PageTurnArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Turn page arrow"),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(2 2)","key":1},[React.createElement("polygon",{"fill":"#46CCC5","points":"0 .001 0 67.275 48.053 35.044","key":0}),React.createElement("polygon",{"fill":"#41B7AE","points":"0 50.72 23.364 33.638 0 16.554","key":1})])]);
}

PageTurnArrow.defaultProps = {"width":"52","height":"72","viewBox":"0 0 52 72"};

module.exports = PageTurnArrow;

PageTurnArrow.default = PageTurnArrow;
